// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2dcKl","content":"ManualTimeModal_content__1yz7F"};